module.exports = __webpack_public_path__ + "static/microsoft-edge-4206ffc3fd68bc7b00a629e9e18424c2.mp4";